// extracted by mini-css-extract-plugin
export var blue = "_3e-f";
export var brand = "_3e-b";
export var darkGrey = "_3e-e";
export var disabled = "_3e-4";
export var disabledSubtle = "_3e-5";
export var error = "_3e-6";
export var green = "_3e-g";
export var grey = "_3e-d";
export var icon = "_3e-0";
export var inherit = "_3e-a";
export var lightGrey = "_3e-c";
export var orange = "_3e-i";
export var pink = "_3e-k";
export var primary = "_3e-1";
export var purple = "_3e-l";
export var red = "_3e-j";
export var secondary = "_3e-2";
export var success = "_3e-9";
export var tertiary = "_3e-3";
export var warning = "_3e-7";
export var warningSecondary = "_3e-8";
export var white = "_3e-m";
export var yellow = "_3e-h";